import { Direction } from './Direction';

export const sortString = ({
  a,
  b,
  sortDirection,
}: {
  a: string;
  b: string;
  sortDirection?: Direction;
}) => {
  if (sortDirection === Direction.Ascending) {
    return a.localeCompare(b);
  } else if (sortDirection === Direction.Descending) {
    return b.localeCompare(a);
  } else {
    return 0;
  }
};
